import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  query GeneralLedgerCount(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $searchTerm: String
    $filter: GeneralLedgerFilterInput
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              rate {
                glCount(searchTerm: $searchTerm, filter: $filter)
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.GeneralLedgerCountQuery,
    number,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'rate',
              graphql.transformers.OUT.select(
                'glCount',
                transformers.PASS_THROUGH,
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  0,
)

export const executor = graphql.createExecutor<
  graphql.schema.GeneralLedgerCountQuery,
  number,
  graphql.schema.GeneralLedgerCountQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
